module.exports = __webpack_public_path__ + "static/media/009.90e08c51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/009.jpg
// module id = 356
// module chunks = 0